import { observer } from 'mobx-react';
import { Button } from '@execonline-inc/execonline-ui';
import { T } from '../../../../../../../../Translations';
import { useEnrollmentModalContext } from '../../../../Common';

function CancelButton() {
  const { onClose } = useEnrollmentModalContext();

  return (
    <Button
      variant="text"
      color="gray"
      data-intercom-target="discovery-portal-enrollment-cancel-button"
      onClick={onClose}
    >
      <T kind="Cancel" />
    </Button>
  );
}

export default observer(CancelButton);
